import {
  LuSearch,
  LuChevronDown,
  FiCalendar,
} from "@/Components/Icons/Icons.jsx";

export default {
  row1 :[
  {
    column: "column1",
    columnWidth: "70%",
    rows: {
      row1: [
        {
          name: "exportShipmentAnnexIECode",
          label: "IE Code Of EOU",
          component: "text-field",
          icon: LuSearch,
          iconColor: "gray-400",
          endpoint: "getCustomer",
          type: "autocomplete",

        },
        {
          name: "exportShipmentAnnexBranchSNo",
          label: "Branch SI.No.",
          component: "text-field",
          dataType:"int"
        },
      ],
      row2: [
        {
          name: "exportShipmentAnnexExamDate",
          label: "Examination Date",
          component: "dateselector",
          endIconName: FiCalendar,
          width: "50%",
        },
        {
          name: "exportShipmentAnnexExaminingOfficer",
          label: "Examining Officer",
          component: "text-field",
           width: "50%",
        },
      ],
      row3: [

        {
          name: "exportShipmentAnnexExaminingOfficerDesignation",
          label: "Designation",
          component: "text-field",
        },
        {
          name: "exportShipmentAnnexSupervisingOfficer",
          label: "Supervising Officer",
          component: "text-field",
        },
      ],
      row4: [

        {
          name: "exportShipmentAnnexSupervisingOfficerDesignation",
          label: "Designation",
          component: "text-field",
        },
        {
          name: "exportShipmentAnnexCommissionerate",
          label: "Commissionerate",
          component: "text-field",
        },
      ],
      row5: [

        {
          name: "exportShipmentAnnexCommisionerateDivision",
          label: "Division",
          component: "text-field",
        },
        {
          name: "exportShipmentAnnexRange",
          label: "Range",
          component: "text-field",
        },
      ],
      row6: [
        {
          name: "exportShipmentAnnexVerifiedByExaminingOfficer",
          label: "Verified by Examining Officer",
          component: "checkboxbox",
        },
        {
          name: "exportShipmentAnnexSampleForwarder",
          label: "Sample Forwarded",
          component: "checkboxbox",
          sx: { ml: 12 },
        },
      ],
      row7: [
        {
          name: "exportShipmentAnnexSealNo",
          label: "Seal Number",
          component: "text-field",
          width: "50%",
        },
      ],

      // row8: [
      //   {
      //     name: "document",
      //     actionText: "Document Name",
      //     component: "typographytext",
      //     actionTextColor:"var(--blue)",
      //     size:"120px"
      //   },
      // ],

    },
  },
]
};
